import styled from "styled-components";
import { theme } from "@themes";

export const ButtonOk = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 36px;
  left: 732px;
  top: 336px;
  background: ${({ theme }) => theme.button.primary};
  border-radius: 4px;
  border: none;
  margin: 1em auto;
  color: white;
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.gray[200]};
    text-decoration: none;
    background-color: transparent;
  }
`;
export const ContentModalCreate = styled.div`
  position: absolute;
  left: 35.2%;
  right: 35.2%;
  top: 3.64%;
  bottom: 75.77%;
  background: ${({ theme }) => theme.neutral.white};
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  box-sizing: border-box;
  box-shadow: 2px 2px 25px ${({ theme }) => theme.shadows.strong};
  border-radius: 4px;
  height: fit-content;
`;

export const CloseModalCreate = styled.div`
  height: 3em;
  width: 100%;
  text-align: end;
  padding: 1em;
  font-weight: 600;
  cursor: pointer;
  a {
    color: ${({ theme }) => theme.neutral.black};
    text-decoration: none;
    background-color: transparent;
  }
`;

export const TextModalCreate = styled.div`
  height: 9em;
  width: 100%;
  border: solid 1px rgba(230, 230, 230, 1);
  display: inline-flex;
  align-items: center;
  padding: 0em 75px;
  svg {
    font-size: 3em;
  }
  p {
    margin: 0 15px;
    color: ${({ theme }) => theme.neutral.black};
  }
`;
